import { OwnerSpaceModeEnum } from '@/lib/graphql'

export const getOwnerSpaceModePermission = ({
  requiredPermission,
  userPermission,
}: {
  requiredPermission: OwnerSpaceModeEnum
  userPermission: OwnerSpaceModeEnum | undefined | null
}) => {
  if (!userPermission) {
    return false
  }

  const permissionHierarchy = {
    [OwnerSpaceModeEnum.FULL]: [OwnerSpaceModeEnum.FULL],
    [OwnerSpaceModeEnum.LIGHT]: [
      OwnerSpaceModeEnum.FULL,
      OwnerSpaceModeEnum.LIGHT,
    ],
    [OwnerSpaceModeEnum.PREVIEW]: [
      OwnerSpaceModeEnum.FULL,
      OwnerSpaceModeEnum.LIGHT,
      OwnerSpaceModeEnum.PREVIEW,
    ],
  }

  const hasPermission =
    permissionHierarchy[requiredPermission].includes(userPermission)

  return hasPermission
}
